export default {
  socials: {
    instagram: 'https://instagram.com/lasercardsco',
    X: 'https://x.com/lasercardsco',
    threads: 'https://www.threads.net/@lasercardsco',
  },
};
